import type {
  CompliancePolicy,
  CompliancePolicyGetInput,
  CompliancePolicyGetSuccess,
  CompliancePolicyId,
} from '@terros/common'
import type { GetHookResponse } from '../../hooks'
import { useTantalimQuery } from '../../query'
import { compliancePolicyKey } from '../../keys'

export function useCompliancePolicy(policyId: CompliancePolicyId): GetHookResponse<CompliancePolicy> {
  return useTantalimQuery<CompliancePolicyGetInput, CompliancePolicyGetSuccess, CompliancePolicy>({
    url: '/compliance/policy/get',
    queryKey: compliancePolicyKey(policyId),
    input: {
      policyId,
    },
    convertResponse: (data) => data.policy,
  })
}
